import React from 'react'
import { isUrlExternal, Link } from '../../../../utils/link'
import { linkBlockClasses } from '../../../../utils/style'
import { convertReactNodeToString, getClassName } from '../../../../utils/utils'
import { useInView } from '../../../hooks/useInView'
import { LinkBlock } from '../blocksState'

export type LinkBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  introClassName: string
  contentClassName: string
  listClassName: string
  itemClassName: string
  linkClassName: string
  linkLabelClassName: string
  linkTextClassName: string
  linkIconClassName: string
  iconExternalId: string
  iconInternalId: string
}>

export const LinkBlockLayout = (props: LinkBlock) => {
  const { inview, index, intro, items, SVGIcon, title } = props
  const classes = linkBlockClasses(convertReactNodeToString(title).toLowerCase().includes('folders') ? true : false)

  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("LinkBlockLayout inView:", inview),
    !inview?.triggerOnce
  )

  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(classes, 'innerClassName', 'py-5')}>
        {(title || intro) && (
          <header className={getClassName(classes, 'headerClassName', '')}>
            {title && (
              <h2 className={getClassName(classes, 'titleClassName', 'mb-3')}>
                <span id={`${index}`} aria-hidden="true" className="block__anchor" />
                {title}
              </h2>
            )}
            {intro && <p className={getClassName(classes, 'introClassName', '')}>{intro}</p>}
          </header>
        )}

        {items && items.count() > 0 && (
          <div className={getClassName(classes, 'contentClassName', '')}>
            <ul className={getClassName(classes, 'listClassName', 'list-unstyled mb-0 row')}>
              {items.toArray().map(
                (item) =>
                  item.title && (
                    <li
                      key={`link-${index}-${item.title}`}
                      className={getClassName(classes, 'itemClassName', 'col-md-6')}
                    >
                      <Link
                        url={item.url}
                        title={item.title}
                        className={getClassName(
                          classes,
                          'linkClassName',
                          'btn btn-link w-100 text-left border-bottom rounded-0 pl-0'
                        )}
                      >
                        {item.title && (
                          <p className={getClassName(classes, 'linkLabelClassName', 'm-0')}>{item.title}</p>
                        )}
                        {item.text && (
                          <p className={getClassName(classes, 'linkTextClassName', 'small m-0')}>{item.text}</p>
                        )}
                        {SVGIcon && (
                          <svg
                            className={getClassName(classes, 'linkIconClassName', '')}
                            aria-hidden="true"
                            width={SVGIcon.width ? SVGIcon.width : '24px'}
                            height={SVGIcon.height ? SVGIcon.height : '24px'}
                          >
                            <use
                              xlinkHref={`${isUrlExternal(item.url)
                                  ? getClassName(classes, 'iconExternalId', '#icon--external')
                                  : getClassName(classes, 'iconInternalId', '#icon--chevron-right-large')
                                }`}
                            />
                          </svg>
                        )}
                      </Link>
                    </li>
                  )
              )}
            </ul>
          </div>
        )}
      </div>
    </section>
  )
}
